module.exports = __webpack_public_path__ + "img/car_5 - 副本.1840557a.png";